<template>
    <v-card 
        style="height:calc(100vh - 100px);" 
        class="mr-3 pa-3 "
    >

		<v-card-title
			  class="text_primary pl-0"
		>
            設定
            <v-spacer></v-spacer>

			<v-btn
                v-if="$route.params.iframe_id"
                outlined
				class="text_default btn_default btn_default_bg_linear  mr-3"
                @click="displayEmbedCode"
			>
                <v-icon>mdi-xml</v-icon>
				取得嵌入原始碼
			</v-btn>

			<v-btn
				color="#5087e6"
				class="white--text"
                @click="saveConfig"
			>
				儲存
			</v-btn>

		</v-card-title>

		<v-divider></v-divider>
        
        <v-card-text id="setting_container" class="pl-0 pr-0" style="overflow: scroll; max-height: calc(100% - 100px);">
            <v-form style="max-width:95%; ">
                <v-card-subtitle
                    id="required_field"
                    class="pl-0 pr-0 mt-0 mb-0 text-h6 pt-0 pb-0"
                >
                    基本
                </v-card-subtitle>
                <v-row>
                    <v-col
                        cols="12"
                    >
                        <h6

                            class="text-field-label "
                        >
                            設定檔名稱<span class="required_field">(必填)</span>:
                        </h6>
                        <v-text-field
                            @change="changeNameField"
                            @blur="changeNameField"
                            placeholder="商品下殺限時倒數計時"
                            v-model="config.name"
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                        ></v-text-field>
                        <p
                            class="mb-0"
                            v-if="config.error_message.name"
                            v-html="config.error_message.name"
                        ></p>
                    </v-col>
                </v-row>

                <!-- <v-row>
                    <v-col cols="12">
                        <v-img
                            contain
                            lazy-src="@/assets/timeline.svg"
                            max-height="250"
                            max-width="100%"
                            src="@/assets/time_range.svg"
                        >
                        </v-img>

                    </v-col>

                </v-row> -->

                <v-row>
                    <v-col
                        cols="6"
                    >
                        <h6
                            class="text-field-label"
                        >
                            顯示開始時間<span class="required_field">(必填)</span>:
                        </h6>
						<date-picker 
                            :shortcuts="$utils.date_picker_shorcuts"
                            @change="changeTimeField"
                            @blur="changeTimeField"
                            class="date-picker"
							v-model="config.start_at" 
							type="datetime"
						>
						</date-picker>
                        <p
                            class="mb-0"
                            v-if="config.error_message.start_at"
                            v-html="config.error_message.start_at"
                        ></p>
                        <!-- <v-text-field
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                        ></v-text-field> -->
                    </v-col>

                    <v-col
                        cols="6"
                    >
                        <h6
                            class="text-field-label"
                        >
                            顯示結束時間<span class="required_field">(必填)</span>:
                        </h6>
						<date-picker
                            :shortcuts="$utils.date_picker_shorcuts" 
                            @change="changeTimeField"
                            @blur="changeTimeField"
                            class="date-picker"
							v-model="config.end_at" 
							type="datetime"
						>
						</date-picker>
                        <p
                            class="mb-0"
                            v-if="config.error_message.end_at"
                            v-html="config.error_message.end_at"
                        ></p>
                    </v-col>

                </v-row>

                <v-row>
                    <v-col
                        cols="6"
                    >
                        <h6
                            class="text-field-label"
                        >
                            活動開始時間<span class="required_field">(必填)</span>:
                        </h6>
						<date-picker
                            :shortcuts="$utils.date_picker_shorcuts" 
                            class="date-picker"
							v-model="config.campaign_start_at" 
							type="datetime"
						>
						</date-picker>
                    </v-col>

                    <v-col
                        cols="6"
                    >
                        <h6
                            class="text-field-label"
                        >
                           活動結束時間<span class="required_field">(必填)</span>:
                        </h6>
						<date-picker 
                            :shortcuts="$utils.date_picker_shorcuts"
                            class="date-picker"
							v-model="config.campaign_end_at" 
							type="datetime"
						>
						</date-picker>
                    </v-col>

                </v-row>

                <v-row>
                    <v-col
                        cols="6"
                    >
                        <v-checkbox
                            hide-details
                            label="同開始結束時間"
                            @click="sameAsStartRange"
                        ></v-checkbox>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col
                        cols="12"
                    >
                        <h6

                            class="text-field-label "
                        >
                            活動結束後每幾天重複循環:
                        </h6>
                        <v-text-field
                            v-model="config.add_column.repeat_day"
                            type="number"
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                        ></v-text-field>
                        <div v-if="config.add_column.repeat_day !== 0">
                            <span style="color:red;">{{$utils.displayISOString(config.campaign_end_at)}}</span>後，會每
                            
                            <span style="color:red;">{{config.add_column.repeat_day}} </span> 天重複循環倒數，顯示 <span style="color:red;">活動進行中</span> 的內容，直到
                            <span style="color:red;">{{$utils.displayISOString(config.end_at)}}</span>
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col
                        cols="12"
                    >
                        <h6

                            class="text-field-label "
                        >
                            倒數計時器高度:
                        </h6>
                        <v-text-field
                            v-model="config.iframe_height"
                            type="number"
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-card-subtitle
                    class="pl-0 pr-0 text-h6 pt-3 pb-2"
                >
                    倒數數字
                </v-card-subtitle>

                <v-row>
                    
                    <v-col
                        cols="6"
                    >
                        <h6
                            class="text-field-label"
                        >
                            左漸層顏色:
                        </h6>
                        <v-text-field
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                            v-model="config.add_column.timer_style.time_1.color" 
                            class="ma-0 pa-0" 
                        >

                        <template v-slot:append>
                            <v-menu 
                                v-model="config.add_column.timer_style.time_1.menu" 
                                top 
                                nudge-bottom="105" nudge-left="16" 
                                :close-on-content-click="false"
                            >
                                <template v-slot:activator="{ on }">
                                    <div :style="swatchStyle(config.add_column.timer_style.time_1)" v-on="on">
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="pa-0">
                                        <v-color-picker
                                            mode="hexa" 
                                            v-model="config.add_column.timer_style.time_1.color" 
                                            flat 
                                        />
                                    </v-card-text>
                                </v-card>							
                            </v-menu>
                        </template>	
                        </v-text-field>	

                    </v-col>

                    <v-col
                        cols="6"
                    >
                        <h6
                            class="text-field-label"
                        >
                            右漸層顏色:
                        </h6>
                        <v-text-field
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                            v-model="config.add_column.timer_style.time_2.color" 
                            class="ma-0 pa-0" 
                        >

                        <template v-slot:append>
                            <v-menu 
                                v-model="config.add_column.timer_style.time_2.menu" 
                                top 
                                nudge-bottom="105" nudge-left="16" 
                                :close-on-content-click="false"
                            >
                                <template v-slot:activator="{ on }">
                                    <div :style="swatchStyle(config.add_column.timer_style.time_2)" v-on="on">
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="pa-0">
                                        <v-color-picker
                                            mode="hexa" 
                                            v-model="config.add_column.timer_style.time_2.color" 
                                            flat 
                                        />
                                    </v-card-text>
                                </v-card>							
                            </v-menu>
                        </template>	
                        </v-text-field>	
                    </v-col>
                </v-row>

                <v-row>
                    <v-col
                        cols="12"
                    >
                        <h6

                            class="text-field-label"
                        >
                            大小:
                        </h6>
                        <v-text-field
                            v-model="config.add_column.timer_style.time_size"
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                            type="number"
                        ></v-text-field>
                    </v-col>

                </v-row>

                <v-card-subtitle
                    class="pl-0 pr-0 text-h6 pt-3 pb-2"
                >
                    時間單位文字
                </v-card-subtitle>
                <v-row>
                    <v-col
                        cols="6"
                    >
                        <h6

                            class="text-field-label "
                        >
                            顏色:
                        </h6>
                        <v-text-field
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                            v-model="config.add_column.timer_style.unit.color" 
                            class="ma-0 pa-0" 
                        >

                        <template v-slot:append>
                            <v-menu 
                                v-model="config.add_column.timer_style.unit.menu" 
                                top 
                                nudge-bottom="105" nudge-left="16" 
                                :close-on-content-click="false"
                            >
                                <template v-slot:activator="{ on }">
                                    <div :style="swatchStyle(config.add_column.timer_style.unit)" v-on="on">
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="pa-0">
                                        <v-color-picker
                                            mode="hexa" 
                                            v-model="config.add_column.timer_style.unit.color" 
                                            flat 
                                        />
                                    </v-card-text>
                                </v-card>							
                            </v-menu>
                        </template>	
                        </v-text-field>	
                    </v-col>

                    <v-col
                        cols="6"
                    >
                        <h6

                            class="text-field-label "
                        >
                            大小:
                        </h6>
                        <v-text-field
                            v-model="config.add_column.timer_style.unit.size"
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                            type="number"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-card-subtitle
                    class="pl-0 pr-0 text-h6 pt-3 pb-2"
                >
                    分隔冒號
                </v-card-subtitle>
                <v-row>
                    <v-col
                        cols="6"
                    >
                        <h6

                            class="text-field-label "
                        >
                            顏色:
                        </h6>
                        <v-text-field
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                            v-model="config.add_column.timer_style.symbol.color" 
                            class="ma-0 pa-0" 
                        >

                        <template v-slot:append>
                            <v-menu 
                                v-model="config.add_column.timer_style.symbol.menu" 
                                top 
                                nudge-bottom="105" nudge-left="16" 
                                :close-on-content-click="false"
                            >
                                <template v-slot:activator="{ on }">
                                    <div :style="swatchStyle(config.add_column.timer_style.symbol)" v-on="on">
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="pa-0">
                                        <v-color-picker
                                            mode="hexa" 
                                            v-model="config.add_column.timer_style.symbol.color" 
                                            flat 
                                        />
                                    </v-card-text>
                                </v-card>							
                            </v-menu>
                        </template>	
                        </v-text-field>	
                    </v-col>

                    <v-col
                        cols="6"
                    >
                        <h6

                            class="text-field-label "
                        >
                            大小:
                        </h6>
                        <v-text-field
                            v-model="config.add_column.timer_style.symbol.size"
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                            type="number"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col
                        cols="6"
                    >
                        <h6

                            class="text-field-label "
                        >
                            向下位移:
                        </h6>
                        <v-text-field
                            v-model="config.add_column.timer_style.symbol.top"
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                            type="number"
                        ></v-text-field>
                    </v-col>

                    <v-col
                        cols="6"
                    >
                        <h6

                            class="text-field-label "
                        >
                            間距:
                        </h6>
                        <v-text-field
                            v-model="config.add_column.timer_style.symbol.letter_spacing"
                            required
                            height="12"
                            dense
                            outlined
                            validate-on-blur
                            hide-details
                            type="number"
                        ></v-text-field>
                    </v-col>
                </v-row>

            </v-form>

            <v-tabs
                fixed-tabs
                class="campaign-tab mt-3"
                v-model="selected_tab"

            >
                <template v-for="(setting, idx) in config.settings">
                    <v-tab 
                        :key="setting.type_name"
                        @click="changeTab(setting)"
                    >
                        {{setting.tab_name}}
                    </v-tab>
                    <v-divider v-if="idx + 1 !== config.settings.length" vertical inset :key="idx"></v-divider>
                </template>
            </v-tabs>

            <v-tabs-items v-model="selected_tab">
                <v-tab-item
                    v-for="(setting, idx) in config.settings"
                    :key="idx"
                >
                    <!-- 這個應該可以獨立拉componet但我要先他會動所以不拉 -->
                    <v-card flat class="pl-0 pr-0">
                        <v-card-text class="pl-0 pr-0">
                                <v-card-subtitle
                                    class="pl-0 pr-0 text-h6 pt-3 pb-2 "
                                >
                                    活動文字
                                </v-card-subtitle>
                                <v-row>
                                    <v-col
                                        cols="12"
                                    >
                                        <h6

                                            class="text-field-label "
                                        >
                                            文字:
                                        </h6>
                                        <v-text-field
                                            v-model="setting.campaign_text.text"
                                            required
                                            height="12"
                                            dense
                                            outlined
                                            validate-on-blur
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col
                                        cols="6"
                                    >
                                        <h6

                                            class="text-field-label "
                                        >
                                            顏色:
                                        </h6>
                                        <v-text-field
                                            required
                                            height="12"
                                            dense
                                            outlined
                                            validate-on-blur
                                            hide-details
                                            v-model="setting.campaign_text.color" 
                                            class="ma-0 pa-0" 
                                        >

                                        <template v-slot:append>
                                            <v-menu 
                                                v-model="setting.campaign_text.menu" 
                                                top 
                                                nudge-bottom="105" nudge-left="16" 
                                                :close-on-content-click="false"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <div :style="swatchStyle(setting.campaign_text)" v-on="on">
                                                    </div>
                                                </template>
                                                <v-card>
                                                    <v-card-text class="pa-0">
                                                        <v-color-picker
                                                            mode="hexa" 
                                                            v-model="setting.campaign_text.color" 
                                                            flat 
                                                        />
                                                    </v-card-text>
                                                </v-card>							
                                            </v-menu>
                                        </template>	
                                        </v-text-field>	
                                    </v-col>

                                    <v-col
                                        cols="6"
                                    >
                                        <h6

                                            class="text-field-label "
                                        >
                                           大小:
                                        </h6>
                                        <v-text-field
                                            v-model="setting.campaign_text.size"
                                            required
                                            height="12"
                                            dense
                                            outlined
                                            validate-on-blur
                                            hide-details
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-card-subtitle
                                    class="pl-0 pr-0 text-h6 pt-3 pb-2"
                                    color="#008edd"
                                >
                                    背景顏色
                                </v-card-subtitle>

                                <v-row>
                                    
                                    <v-col
                                        cols="6"
                                    >
                                        <h6
                                            class="text-field-label"
                                        >
                                            左漸層顏色:
                                        </h6>
                                        <v-text-field
                                            required
                                            height="12"
                                            dense
                                            outlined
                                            validate-on-blur
                                            hide-details
                                            v-model="setting.background_1.color" 
                                            class="ma-0 pa-0" 
                                        >

                                        <template v-slot:append>
                                            <v-menu 
                                                v-model="setting.background_1.menu" 
                                                top 
                                                nudge-bottom="105" nudge-left="16" 
                                                :close-on-content-click="false"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <div :style="swatchStyle(setting.background_1)" v-on="on">
                                                    </div>
                                                </template>
                                                <v-card>
                                                    <v-card-text class="pa-0">
                                                        <v-color-picker
                                                            mode="hexa" 
                                                            v-model="setting.background_1.color" 
                                                            flat 
                                                        />
                                                    </v-card-text>
                                                </v-card>							
                                            </v-menu>
                                        </template>	
                                        </v-text-field>	

                                    </v-col>

                                    <v-col
                                        cols="6"
                                    >
                                        <h6
                                            class="text-field-label"
                                        >
                                            右漸層顏色:
                                        </h6>
                                        <v-text-field
                                            required
                                            height="12"
                                            dense
                                            outlined
                                            validate-on-blur
                                            hide-details
                                            v-model="setting.background_2.color" 
                                            class="ma-0 pa-0" 
                                        >

                                        <template v-slot:append>
                                            <v-menu 
                                                v-model="setting.background_2.menu" 
                                                top 
                                                nudge-bottom="105" nudge-left="16" 
                                                :close-on-content-click="false"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <div :style="swatchStyle(setting.background_2)" v-on="on">
                                                    </div>
                                                </template>
                                                <v-card>
                                                    <v-card-text class="pa-0">
                                                        <v-color-picker
                                                            mode="hexa" 
                                                            v-model="setting.background_2.color" 
                                                            flat 
                                                        />
                                                    </v-card-text>
                                                </v-card>							
                                            </v-menu>
                                        </template>	
                                        </v-text-field>	
                                    </v-col>
                                </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-card-text>

        <!-- <v-divider></v-divider> -->
        

        <!-- <v-card-text class="pa-0 mt-3">

        </v-card-text>
        <v-divider></v-divider> -->

        <!-- <v-card-text class="pl-0 pr-0">
            <v-card-subtitle
                class="pl-0 pr-0 text-h6 pt-3 pb-2"
            >
                預覽
            </v-card-subtitle>


            <v-row>
                <v-col
                    cols="12"
                >
                    <p>選擇時間來看看結果吧！</p>
                    <p>活動開始時間: {{ displayTime(config.start_at) }}</p>
                    <p>活動開始時間: {{ displayTime(config.end_at) }}</p>
                    <h6
                        class="text-field-label"
                    >
                        指定預覽時間:
                    </h6>
                    <date-picker 
                        @change="previewRange(config.start_at, config.end_at, config.preview_at)"
                        class="date-picker"
                        v-model="config.preview_at" 
                        type="datetime"
                    >
                    </date-picker>
                    <p
                        class="pb-0 pt-0 mb-0"
                        v-if="config.preview_at"
                        v-html="preview_result"
                    >
                    </p>
                </v-col>
            </v-row>
        </v-card-text> -->
        <!-- <v-card-actions>
            <v-spacer></v-spacer>

        </v-card-actions> -->
    </v-card>
</template>

<script>
import {
    apiCreateSetting,
    apiUpdateSetting
} from '@/api/iframe.js'

    // DatePicker!
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import 'vue2-datepicker/locale/zh-tw';

  export default {
    name: 'TimerSetting',
    props: {
        config: Object
    },
    components: {
        DatePicker
    },
    data: function(){
      return {
        selected_tab:null,
        is_preview: false,
        preview_result: ''
      }
    }, 
    created: async function(){
    },
    mounted: function(){

    },
    methods: {
        changeTab: function(setting){
            this.config.selected_setting = setting
            this.config.selected_setting_tab_name = setting.tab_name
        },
        displayTime: function(time){
            if (!time) {
                return '無選擇'
            }

            return this.$utils.getYYYYMMDDHHMMSS(time, '-')
        },
        changeNameField: function(){
            // 檢查檔名是不是空的
            if (!this.config.name) {
                this.config.error_message.name = '<span style="color:red;">此為必填欄位</span>'
            }
            else {
                this.config.error_message.name = ''
            }
        },
        changeTimeField: function(){
            // 檢查start_at / end_at 是不是空的
            if (!this.config.start_at) {
                this.config.error_message.start_at = '<span style="color:red;">此為必填欄位</span>'
            }
            else {
                this.config.error_message.start_at = ''
            }
            if (!this.config.end_at) {
                this.config.error_message.end_at = '<span style="color:red;">此為必填欄位</span>'
            }
            else {
                this.config.error_message.end_at = ''
            }

            // 檢查 start_at 是否大於 end at
            if (this.config.start_at && this.config.end_at) {
                if (new Date(this.config.start_at).getTime() > new Date(this.config.end_at).getTime()) {
                    this.config.error_message.end_at = '<span style="color:red;">不能比活動開始時間早</span>'
                }
                else {
                    this.config.error_message.end_at = ''
                }
            }
        },
        swatchStyle(param) {
            return {
                position: 'absolute',
                backgroundColor: param.color,
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                right: '5px',
                bottom: '5px',
                border: (param.color.indexOf('FFFF') !== -1 || !param.color) ? '1px solid #CCC' : 'none',
                borderRadius: param.menu ? '50%' : '4px',
                transition: 'border-radius 200ms ease-in-out'
            }
        },
        saveConfig: function(){
            console.log(this.config)
            console.log('this.config.settings', this.config.settings)
            let check_results = []
            let that = this
            // 檢查檔名是不是空的
            if (!this.config.name) {
                this.config.error_message.name = '<span style="color:red;">此為必填欄位</span>'
                check_results.push(false)
            }
            else {
                this.config.error_message.name = ''
            }

            // 檢查start_at / end_at 是不是空的
            if (!this.config.start_at) {
                this.config.error_message.start_at = '<span style="color:red;">此為必填欄位</span>'
                check_results.push(false)
            }
            else {
                this.config.error_message.start_at = ''
            }
            if (!this.config.end_at) {
                this.config.error_message.end_at = '<span style="color:red;">此為必填欄位</span>'
                check_results.push(false)
            }
            else {
                this.config.error_message.end_at = ''
            }

            // 檢查 start_at 是否大於 end at
            if (this.config.start_at && this.config.end_at) {
                if (new Date(this.config.start_at).getTime() > new Date(this.config.end_at).getTime()) {
                    this.config.error_message.end_at = '<span style="color:red;">不能比顯示開始時間早</span>'
                    check_results.push(false)
                }
                else {
                    this.config.error_message.end_at = ''
                }
            }

            if (check_results.indexOf(false) !== -1){
                console.log(check_results)
                console.log('有不過的')
                let target_ele = document.querySelector(`#required_field`);
                this.$utils.scroll_to_in_ele('setting_container', target_ele.offsetTop - 80)
                return
            }

            let data = {
                container_id: this.$route.params.container_id,
                name: this.config.name,
                start_at: this.$utils.getYYYYMMDDHHMMSS(this.config.start_at, '-'),
                end_at: this.$utils.getYYYYMMDDHHMMSS(this.config.end_at, '-'),
                iframe_height: this.config.iframe_height,
                timer_style: JSON.stringify(this.config.timer_style),
                settings: JSON.stringify(this.config.settings),
                add_column: JSON.stringify(this.config.add_column),
            }

            if (this.config.campaign_start_at) {
                data['campaign_start_at'] = this.$utils.getYYYYMMDDHHMMSS(this.config.campaign_start_at, '-')
            }
            else {
                data['campaign_start_at'] = this.$utils.getYYYYMMDDHHMMSS(this.config.start_at, '-')
            }

            if (this.config.campaign_end_at) {
                data['campaign_end_at'] = this.$utils.getYYYYMMDDHHMMSS(this.config.campaign_end_at, '-')
            }
            else {
                data['campaign_end_at'] = this.$utils.getYYYYMMDDHHMMSS(this.config.end_at, '-')
            }

            console.log(data)
            console.log(this.$route.params.org_id)
            
            // 根據 route是否帶有id決定要update還是新增
            if (!this.$route.params.iframe_id) {
                apiCreateSetting(data, this.$route.params.org_id).then(function(resp){
                    console.log(resp)
                    let data = resp.data.data
                    let id = data.id
                    that.$root.vtoast.show({ message: "保存成功" , color: 'primary'})
                    that.$router.push('/' + that.$route.params.org_id +'/' + that.$route.params.container_id + '/optimize_page/iframe_timer/' + id + '/edit')
                }).catch(function(error){
                    that.$root.vtoast.show({ message: "保存計時器失敗，原因: " + (error.response ? error.response : error) }) 
                })
            }
            else {
                apiUpdateSetting(
                    data,this.$route.params.iframe_id, this.$route.params.org_id
                ).then(function(){
                    that.$root.vtoast.show({ message: "保存成功" , color: 'primary'})
                }).catch(function(error){
                    that.$root.vtoast.show({ message: "保存計時器失敗，原因: " + (error.response ? error.response : error) }) 
                })
            }

        },
        previewRange: function(start_at, end_at, preview_at){

            if (!start_at || !end_at) {
                console.log('start_at/end_at為空，無法計算')
                this.preview_result = '<span style="color:red;">無選擇活動開始或是活動結束時間，無法預覽</span>'
                return
            }

            if (new Date(start_at).getTime() > new Date(end_at).getTime()) {
                console.log('start_at 大於 end_at為空，無法計算')
                this.preview_result = '<span style="color:red;">無選擇活動開始或是活動結束時間，無法預覽</span>'
                return
            }

            this.preview_result = ''
            console.log(preview_at)
            if (preview_at) {
                if (new Date(preview_at).getTime() < new Date(start_at).getTime()){
                    this.preview_result = '<p>預覽的時間為: <span style="color:red;"> 活動開始前 </span></p>'
                    this.selected_tab = 0
                    this.config.selected_setting = this.config.settings[0]
                }

                if (new Date(preview_at).getTime() >= new Date(start_at).getTime() && new Date(preview_at).getTime() <= new Date(end_at).getTime()){
                    this.preview_result = '<p>預覽的時間為: <span style="color:red;"> 活動進行中 </span></p>'
                    this.selected_tab = 1
                    this.config.selected_setting = this.config.settings[1]
                }

                if (new Date(preview_at).getTime() > new Date(end_at).getTime()){
                    this.preview_result = '<p>預覽的時間為: <span style="color:red;"> 活動結束後 </span></p>'
                    this.selected_tab = 2
                    this.config.selected_setting = this.config.settings[2]
                }

            } 
        },
        displayEmbedCode: function(){
            this.$emit('displayEmbedCode')
        },
        sameAsStartRange: function(){
            console.log('wowow')
            this.config.campaign_start_at = this.config.start_at
            this.config.campaign_end_at = this.config.end_at
        }

    },
    watch: {
    },
    computed: {
    }     
  }
</script>
<style scoped>
h4 {
    color: #5b5b5b;
}
.text-field-label {
    font-size: 16px;
    margin: 0.5em 0px;
}
.row + .row {
    margin-top: 0px;
}
.campaign-tab {
    border: 1px #CCC solid;
    position: sticky;
    top: -12px;
    z-index: 1;
    
}
.date-picker{
    width: 100%;
}
.required_field {
    color: red;
}
</style>
<style>
.date-picker > .mx-input-wrapper > input {
    height: 40px;
}
</style>